import { IModal } from '@epam/uui-core';
import { ReactNode } from 'react';

export interface BaseModalProps extends IModal<string> {
  close: () => void;
  title: string;
  successAction: string;
  abortAction: string;
  children?: ReactNode;
  isDisabled?: boolean;
}

export const MODAL_ACTION = {
  DELETE: 'Delete',
  SAVE: 'Save changes',
  DISCARD: 'Discard changes',
  CANCEL: 'Cancel',
  CHANGE: 'Change',
  YES: 'Yes',
  CONFIRM: 'Confirm',
} as const;

export type ModalAction = (typeof MODAL_ACTION)[keyof typeof MODAL_ACTION];

export const MODAL_ACTION_TYPE = {
  DELETE: 'delete',
  CONFIRM: 'confirm',
  SAVE: 'save',
  SHOW_DATA: 'showData',
} as const;

export type ModalActionType =
  (typeof MODAL_ACTION_TYPE)[keyof typeof MODAL_ACTION_TYPE];
